module.exports = __webpack_public_path__ + "static/media/03_03.910cd9fb.png";